module.exports = __webpack_public_path__ + "img/denis_1_3x.f7f748df.jpg";